export const profileRoutes = [
  {
    path: '/profile',
    name: 'profile',
    meta: {
      requiresAuth: true, // all app paths require authentication,
      redirectTo: '/profile'
    },
    component: () => import(/* webpackChunkName: "profile" */ './Profile.vue')
  }
];
